<template>
    <div class="qty-input" :class="{'sm': size === 'sm'}">
        <button class="btn-minus" type="button" @click="btnMinusOnClick">-</button>
        <input
            type="text"
            :value="value"
            readonly
        >
        <button class="btn-plus" type="button" @click="btnPlusOnClick">+</button>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                type: Number
            },
            max: {
                type: Number,
                default: 99
            },
            min: {
                type: Number,
                default: 1
            },
            size: {
                type: 'normal' | 'small',
                default: 'normal'
            },
            onChangeHandler: {
                type: Function,
                default: () => {}
            }
        },
        methods: {
            validate(value) {
                return Number.isInteger(value) && value <= this.max && value >= this.min;
            },
            btnMinusOnClick() {
                const newValue = this.$props.value-1;
                if(this.validate(newValue)) {
                    this.$emit('input', newValue)
                }
            },
            btnPlusOnClick() {
                const newValue = this.$props.value+1;
                if(this.validate(newValue)) {
                    this.$emit('input', newValue)
                }
            },
        },
        watch: {
            value(val) {
                this.onChangeHandler(val);
            }
        }
    }
</script>

<style  lang="stylus" type="text/stylus">
    .qty-input {
        display flex;
        > * {
            display: inline-block;
        }
        input {
            width: 30px;
            text-align: center;
            border: 0;
        }
        button {
            background-color: #ffffff;
            border: 1px solid #000000;
            box-shadow: none;
            width: 30px;
            height: 30px;
            cursor: pointer;
            display: flex;
            justify-content: center;
            align-items: center;
            &:hover, &:active, &:focus {
                background-color: #000000;
                border-color: #ffffff;
                color: #ffffff;
                outline: none;
            }
        }
        &.sm {
            font-size: 0.8em;
            input {
                width: 20px;
            }
            button {
                width: 20px;
                height: 20px;
            }
        }
    }
</style>